/*@flow*/
import { useEffect } from 'react';
import getLoadKey from 'lib/getLoadKey';
import { isXSmallScreen } from 'lib/getScreenWidth';
import delay from 'lib/delay';
import useCommands from './useCommands';

export default function useLoadedPanel() {
  let loadedPanelName = getLoadKey('panelName', '');
  const cmd = useCommands();

  // Ensures to map the name of list_view to LOCATION_DETAILS.
  // Do not delete.
  if (loadedPanelName.toLowerCase() === 'list_view') {
    loadedPanelName = 'LOCATION_DETAILS';
  }

  useEffect(() => {
    if (!loadedPanelName) return;
    if (isXSmallScreen()) return;
    // HACK: race conditions.
    delay(1500).then(() => {
      cmd.openPanel(loadedPanelName);
    });
  }, [loadedPanelName]);
}
